import { Api } from '@/core/api.js'
import { VCarouselReverseTransition } from 'vuetify/lib'

import router from '@/router.js'
const api = new Api()

// initial state
const state = {
  all: [],
  labels: [],
  categories: {},
  files: {},
  new_files: {},
  current_files: {},
  current_file: false,
  resources_type: [],
  pullFiles: [],
  uploading: false,
  current_section: false,
  current_category: false,
  inform: [],
  url: ''
}

// getters
const getters = {
  getCategories: (state, getters, rootState) => type => {
    return state.categories
  },

  getCurrentCategory: (state, getter, rootState) => {
    return state.current_category
  },

  getCurrentSection: (state, getter, rootState) => {
    return state.current_section
  },

  getFiles: (state, getters, rootState) => id => {
    return state.files
  },

  getNewFiles: (state, getters, rootState) => {
    return state.new_files
  },

  getCurrentFiles: (state, getters, rootState) => id => {
    return state.current_files
  },

  searchFiles: (state, getters, rootState) => {
    // Todo check if param == true
    return state.files
  },

  getCurrentFile: (state, getters, rootState) => {
    return state.current_file
  },

  getResourceByURL: (state, getters, rootState) => url => {
    for (var i in state.files) {
      if (state.files[i].url === url) {
        return state.files[i]
      }
    }

    return false
  },

  getCategoryByURL: (state, getter, rootState) => (type, url) => {
    console.log('getCategoryByURL - ' + type + ' ' + url)
    for (var i in state.categories) {
      var cat1 = state.categories[i]
      console.log('LEVEL 0: ' + cat1.name + ' ' + cat1.url)
      if (cat1.url == url) return cat1.id
      for (var j in cat1.childs) {
        var cat2 = cat1.childs[j]
        console.log('LEVEL 1: ' + cat2.name + ' ' + cat2.url)
        if (cat2.url == url) return cat2.id
        for (var k in cat2.childs) {
          console.log(
            'LEVEL 2: ' + cat2.childs[k].name + ' ' + cat2.childs[k].url
          )
          if (cat2.childs[k].url === url) {
            return cat2.childs[k].id
          }
        }
      }
    }

    return false
  },

  getTypes: (state, getter, rootState) => {
    return state.resources_type
  },

  getTypesCustomizable: (state, getter, rootState) => {
    var types = {}

    for (var k in state.resources_type) {
      if (state.resources_type[k].customizable == '1') {
        types[state.resources_type[k].id] = state.resources_type[k]
      }
    }

    return types
  },

  existURLResource: (state, getters, rootState) => (url, n) => {
    var bFound = false
    for (var k in state.files) {
      //console.log(state.files[k].url)
      if (state.files[k].url == url) {
        return true
      }
    }
    return false
  },

  getUploadsLength: (state, getter, rootState) => {
    var n = 0
    if (state.uploading) n++

    return n + state.pullFiles.length
  },

  getUploading: state => {
    return state.uploading
  },

  getPullUploads: state => {
    return state.pullFiles
  },

  getInform: (state, getters, rootState) => {
    return state.inform
  },

  getUrl: (state, getters, rootState) => {
    return state.url
  }
}

// actions
const actions = {
  loadCategories ({ commit }, { type }) {
    // console.log("loadCategories() with type - "+ type);

    var path = 'section' + (typeof type !== 'undefined' ? '/type/' + type : '')
    return api.get(path).then(function (response) {
      if (response.status) {
        var data = response.data

        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            data[key].visible = false
            data[key].selected = false
            for (const key2 in data[key].childs) {
              data[key].childs[key2].visible = false
              data[key].childs[key2].selected = false
              for (const key3 in data[key].childs[key2].childs) {
                data[key].childs[key2].childs[key3].visible = false
                data[key].childs[key2].childs[key3].selected = false
              }
            }
          }
        }

        return commit('setCategories', { data: data, type: type })
      }
    })
  },

  loadFiles: ({ commit }, { id }) => {
    console.log('LOADFILES() with type - ' + id)

    var path = typeof id !== 'undefined' ? '/section/' + id : ''

    return api.get('resource' + path).then(function (data) {
      if (data.status) {
        console.log(data.data)
        for (const key in data.data) {
          // data.data[key].thumb = 'https://is1-ssl.mzstatic.com/image/thumb/Purple114/v4/10/5d/98/105d9875-89ad-bb9f-1f20-6abcb724875c/AppIcon-0-1x_U007emarketing-0-0-85-220-0-8.png/246x0w.jpg';
        }
        return commit('setFiles', data.data)
      }
    })
  },

  loadNewFiles: ({ commit }) => {
    return api.get('resource/new').then(function (data) {
      if (data.status) {
        console.log(data.data)
        // for ( const key in data.data ) {
        //   //data.data[key].thumb = 'https://is1-ssl.mzstatic.com/image/thumb/Purple114/v4/10/5d/98/105d9875-89ad-bb9f-1f20-6abcb724875c/AppIcon-0-1x_U007emarketing-0-0-85-220-0-8.png/246x0w.jpg';
        // }
        return commit('setNewFiles', data.data)
      }
    })
  },

  loadFile: ({ commit }, id) => {
    console.log('LOADFILE() with id - ' + id)

    return api.get('resource/' + id).then(function (data) {
      if (data.status) {
        console.log(data.data)
        for (const key in data.data) {
          // data.data[key].thumb = 'https://is1-ssl.mzstatic.com/image/thumb/Purple114/v4/10/5d/98/105d9875-89ad-bb9f-1f20-6abcb724875c/AppIcon-0-1x_U007emarketing-0-0-85-220-0-8.png/246x0w.jpg';
        }
        commit('setFile', data.data)
        return commit('setCurrentFile', data.data)
      }
    })
  },

  searchFiles: ({ commit }, { search }) => {
    const encoded = encodeURIComponent(search.trim())
    return api.get('resource/search/-1/' + encoded).then(function (data) {
      if (data.status) {
        console.log(data.data)
        for (const key in data.data) {
          // data.data[key].thumb = 'https://is1-ssl.mzstatic.com/image/thumb/Purple114/v4/10/5d/98/105d9875-89ad-bb9f-1f20-6abcb724875c/AppIcon-0-1x_U007emarketing-0-0-85-220-0-8.png/246x0w.jpg';
        }
        return commit('setFiles', data.data)
      }
    })
  },

  uploadResource: ({ commit, dispatch }, resource) => {
    var file = ''
    var thumb = ''

    var tags = ''
    resource.tags.forEach(tag => {
      tags += '|' + tag
    })
    resource.tags = tags != '' ? tags + '|' : ''

    if (typeof resource.file !== 'string') {
      file = resource.file
      resource.file = '-1'
    }
    if (typeof resource.thumb !== 'string') {
      thumb = resource.thumb
      resource.thumb = '-1'
    } /* else {
        resource.thumb = decodeURIComponent(resource.thumb);
      } */

    var path = resource.id == -1 ? 'add' : resource.id + '/update'
    return api.post('resource/' + path, resource).then(function (data) {
      console.log(data)
      if (data.status) {
        var fileServer = JSON.parse(JSON.stringify(data.data))
        commit('addFile', fileServer)

        data.data.file = file !== '' ? file : data.data.file
        data.data.thumb = thumb !== '' ? thumb : data.data.thumb

        if (typeof file !== 'string' || typeof thumb !== 'string') {
          data.data.lang = data.data.lang.id
          data.data.langname =
            data.data.lang == 'L2F4ckN4SHh3UWc2U1d3TkVaU0dBUT09' ? '_cat' : ''
          data.data.type = data.data.type.id
          var sections = ''
          data.data.sections.forEach(section => {
            if (sections != '') sections += ','
            sections += section.id
          })
          data.data.sections = sections

          commit('addFileToUpload', data.data)
          dispatch('processPullUploads')
        }
      }
    })
  },
  editResource: ({ commit, dispatch }, resource) => {
    return api
      .post('resource/' + resource.id + '/update', resource)
      .then(function (data) {
        console.log(data)
        if (data.status) {
          return commit('addFile', data.data)
        }
      })
  },
  updateStatus: ({ commit, dispatch }, params) => {
    return api
      .post('resource/update', params)
      .then(function (data) {
        console.log(data)
        if (data.status) {
          return commit('updateStatus', params)
        }
      })
  },

  processPullUploads: ({ commit, dispatch, state }) => {
    if (!state.uploading) {
      var pull = [...state.pullFiles].reverse()

      if (pull.length > 0) {
        var nextUploadFile = pull.pop()

        commit('setPullFiles', pull.reverse())

        commit('setUploading', nextUploadFile)
        var uploaderFile = new Uploader()
        // commit("updateUpload", { param: "status", value: 1 });

        if (typeof nextUploadFile.file !== 'string') {
          var fileUploadName = nextUploadFile.file.name.split('.')
          fileUploadName =
            nextUploadFile.url +
            '' +
            nextUploadFile.langname +
            '.' +
            fileUploadName[fileUploadName.length - 1]
          uploaderFile.upload(
            nextUploadFile.file,
            { path: 'files', filename: fileUploadName },
            function (data) {
              commit('updateUpload', { param: 'file', value: data.Location })
              if (typeof nextUploadFile.thumb !== 'string') {
                var uploaderThumb = new Uploader()
                var fileUploadName = nextUploadFile.thumb.name.split('.')
                fileUploadName =
                  'thumb_' +
                  moment().valueOf() +
                  nextUploadFile.url +
                  '.' +
                  fileUploadName[fileUploadName.length - 1]
                uploaderThumb.upload(
                  nextUploadFile.thumb,
                  { path: 'thumb', filename: fileUploadName },
                  function (data) {
                    commit('updateUpload', {
                      param: 'thumb',
                      value: data.Location
                    })
                    dispatch('editResource', state.uploading)
                    commit('setUploading', false)
                    dispatch('processPullUploads')
                  },
                  function () {},
                  function (progress) {
                    console.log(progress)
                    commit('updateUpload', {
                      param: 'thumb_upload',
                      value: progress
                    })
                  }
                )
              } else {
                dispatch('editResource', state.uploading)
                commit('setUploading', false)
                dispatch('processPullUploads')
              }
            },
            function () {},
            function (progress) {
              commit('updateUpload', { param: 'file_upload', value: progress })
            }
          )
        } else if (typeof nextUploadFile.thumb !== 'string') {
          var uploaderThumb = new Uploader()
          var fileUploadName = nextUploadFile.thumb.name.split('.')
          fileUploadName =
            'thumb_' +
            moment().valueOf() +
            nextUploadFile.url +
            '.' +
            fileUploadName[fileUploadName.length - 1]
          uploaderThumb.upload(
            nextUploadFile.thumb,
            { path: 'thumb', filename: fileUploadName },
            function (data) {
              commit('updateUpload', { param: 'thumb', value: data.Location })
              dispatch('editResource', state.uploading)
              commit('setUploading', false)
              dispatch('processPullUploads')
            },
            function () {},
            function (progress) {
              console.log(progress)
              commit('updateUpload', {
                param: 'thumb_upload',
                value: progress
              })
            }
          )
        } else {
          commit('setUploading', false)
          dispatch('processPullUploads')
        }
      }
    }
  },

  removeResource: ({ commit }, id) => {
    return api.get('resource/' + id + '/delete').then(function (data) {
      if (data.status) {
        return commit('removeFile', id)
      }
    })
  },

  uploadSection: ({ commit, dispatch }, section) => {
    var path = section.id == -1 ? 'add' : section.id + '/update'
    return api.post('section/' + path, section).then(function (data) {
      console.log(data)
      if (data.status) {
        data.data.visible = true
        return commit('addSection', data.data)
      }
    })
  },

  removeSection: ({ commit }, id) => {
    return api.get('section/' + id + '/delete').then(function (data) {
      if (data.status) {
        return commit('removeCategory', id)
      }
    })
  },

  loadInform: ({ commit }, dates) => {
    dates.start_date = dates.start_date == '' ? false : dates.start_date
    dates.end_date = dates.end_date == '' ? false : dates.end_date

    return api
      .get('inform/' + dates.start_date + '/' + dates.end_date)
      .then(function (data) {
        if (data.status) {
          var position = 1
          for (const key in data.data) {
            data.data[key].position = position
            position++
          }
          return commit('setInform', data.data)
        }
      })
  },

  loadShortener: ({ commit }, data) => {
    console.log('LOADSHORTENER()')

    return api
      .get('shortener/' + data.resource_id + '/' + data.user_id)
      .then(function (data) {
        if (data.status) {
          return commit('setInform', data.data[0].url)
        }
      })
  },

  logToolkit: ({ commit }, data) => {
    return api.post('log/toolkit', data).then(function (data) {})
  }
}

// mutations
const mutations = {
  setCurrentCategoryFalse (state) {
    state.current_category = false
  },

  setCategories (state, payload) {
    var type = parseInt(payload.type)

    state.categories = payload.data

    var item = false

    if (router.app._route.params.category != undefined) return

    for (var i in state.categories) {
      var cat1 = state.categories[i]
      if (Object.keys(cat1.childs).length == 0) {
        cat1.selected = true
        state.current_category = cat1
        return
      } else {
        cat1.selected = false

        for (var j in cat1.childs) {
          var cat2 = cat1.childs[j]
          if (Object.keys(cat2.childs).length == 0) {
            cat2.selected = true
            state.current_category = cat2
            return
          } else {
            cat2.childs[Object.keys(cat2.childs)[0]].selected = true
            cat2.selected = true
            cat1.selected = true
            cat2.childs[Object.keys(cat2.childs)[0]].visible = true
            cat2.visible = true
            cat1.visible = true

            state.current_category = cat2.childs[Object.keys(cat2.childs)[0]]
            return
          }

          // for(var k in cat2.childs) {
          //   if( typeof payload.type !== 'undefined' ){
          //     cat2.childs[k].selected = true;
          //     cat2.selected = true;
          //     cat1.selected = true;
          //     cat2.childs[k].visible = true;
          //     cat2.visible = true;
          //     cat1.visible = true;

          //     state.current_category = cat2.childs[k];
          //     return;
          //   }

          // }
        }
      }
    }
  },

  selectCategory (state, payload) {
    // Set all categories to visible/selected = false
    for (var i in state.categories) {
      var cat1 = state.categories[i]
      cat1.selected = false
      cat1.visible = false

      for (var j in cat1.childs) {
        var cat2 = cat1.childs[j]
        cat2.visible = false
        cat1.visible = false

        for (var k in cat2.childs) {
          cat2.childs[k].selected = false
          cat2.childs[k].visible = false
        }
      }
    }

    for (var i in state.categories) {
      var cat1 = state.categories[i] // Tab verde

      if (payload && cat1.id == payload.category.id) {
        // Seleccionada de nivel 1
        cat1.selected = true
        cat1.visible = true
        state.current_category = cat1

        if (Object.keys(cat1.childs).length > 0) {
          cat1.childs[Object.keys(cat1.childs)[0]].selected = true
          cat1.childs[Object.keys(cat1.childs)[0]].visible = true
          state.current_category = cat1.childs[Object.keys(cat1.childs)[0]]

          cat2 = cat1.childs[Object.keys(cat1.childs)[0]]

          if (Object.keys(cat2.childs).length > 0) {
            cat2.childs[Object.keys(cat2.childs)[0]].selected = true
            cat2.childs[Object.keys(cat2.childs)[0]].visible = true
            state.current_category = cat2.childs[Object.keys(cat2.childs)[0]]
          }
        }
      } else {
        // Opción de estar seleccionada categoría nivel 2 o 3

        for (var j in cat1.childs) {
          var cat2 = cat1.childs[j]
          if (payload && cat2.id == payload.category.id) {
            cat2.selected = true
            cat1.selected = true
            cat2.visible = true
            cat1.visible = true
            state.current_category = cat2

            if (Object.keys(cat2.childs).length > 0) {
              cat2.childs[Object.keys(cat2.childs)[0]].selected = true
              cat2.childs[Object.keys(cat2.childs)[0]].visible = true
              cat2.selected = true
              cat1.selected = true
              cat2.visible = true
              cat1.visible = true
              state.current_category = cat2.childs[Object.keys(cat2.childs)[0]]
              // state.current_category = cat2;
            }
          }

          for (var k in cat2.childs) {
            if (payload && cat2.childs[k].id == payload.category.id) {
              cat2.childs[k].selected = true
              cat2.selected = true
              cat1.selected = true
              cat2.visible = true
              cat1.visible = true

              state.current_category = cat2.childs[k]
            }
          }
        }
      }
    }
  },

  selectSection (state, section) {
    state.current_section = section
  },

  showCategory (state, payload) {
    if (payload.category.visible == true) {
      payload.category.visible = false
    } else {
      for (var i in state.categories) {
        var cat = state.categories[i]
        cat.visible = false
        for (var j in cat.childs) {
          var subcat = cat.childs[j]
          subcat.visible = false
        }
      }

      payload.category.visible = true
    }
  },

  setFiles (state, files) {
    // if( Object.keys( files ).length > 0 ){
    state.files = files
    // }
    state.current_files = files
  },

  setNewFiles (state, files) {
    state.new_files = files
  },

  addFile (state, file) {
    var files = state.files

    files[file.id] = file

    state.files = { ...files }
  },

  addFileToUpload (state, file) {
    var files = state.pullFiles

    files.push(file)

    state.pullFiles = files
  },

  setFile (state, file) {
    state.files[file.id] = file
  },

  setInform (state, inform) {
    state.inform = inform
  },

  setCurrentFile (state, file) {
    if (file && file.id != -1 && file.sections[0]) {
      file.category = file.sections[0].type
    }
    state.current_file = file
  },

  setCurrentFileByID (state, id) {
    state.current_file = state.files[id]
  },

  setCurrentSectionByID (state, id) {
    for (var i in state.categories) {
      var cat = state.categories[i]
      if (cat.id == id) state.current_section = cat
      else {
        for (var j in cat.childs) {
          var subcat = cat.childs[j]
          if (subcat.id == id) state.current_section = subcat
          else {
            for (var x in subcat.childs) {
              var subsubcat = subcat.childs[x]
              if (subsubcat.id == id) state.current_section = subsubcat
            }
          }
        }
      }
    }
  },

  unsetCurrentFile (state) {
    state.current_file = false
  },

  unsetCurrentSection (state) {
    state.current_section = false
  },

  setPullFiles (state, pull) {
    state.pullFiles = pull
  },

  setUploading (state, upload) {
    state.uploading = upload
  },

  updateStatus (state, params) {
    var new_files = { ...state.files }

    var filesIds = params.files
    var status = params.status

    for (var i in filesIds) {
      new_files[filesIds[i]].status = status.toString()
    }

    state.files = new_files
  },

  updateUpload (state, update) {
    var uploading = { ...state.uploading }

    uploading[update.param] = update.value
    state.uploading = uploading
  },

  expandSection (state, id) {
    for (var k in state.categories) {
      if (state.categories[k].id == id) {
        state.categories[k].selected = true
        for (var k2 in state.categories[k].childs) {
          state.categories[k].childs[k2].visible = true
        }
      } else {
        for (var k2 in state.categories[k].childs) {
          if (state.categories[k].childs[k2].id == id) {
            state.categories[k].childs[k2].selected = true
            for (var k3 in state.categories[k].childs[k2].childs) {
              state.categories[k].childs[k2].childs[k3].visible = true
            }
          }
        }
      }
    }
  },

  lessSection (state, id) {
    for (var k in state.categories) {
      if (state.categories[k].id == id) {
        state.categories[k].selected = false
        for (var k2 in state.categories[k].childs) {
          state.categories[k].childs[k2].visible = false
          state.categories[k].childs[k2].selected = false
          for (var k3 in state.categories[k].childs[k2].childs) {
            state.categories[k].childs[k2].childs[k3].visible = false
          }
        }
      } else {
        for (var k2 in state.categories[k].childs) {
          if (state.categories[k].childs[k2].id == id) {
            state.categories[k].childs[k2].selected = false
            for (var k3 in state.categories[k].childs[k2].childs) {
              state.categories[k].childs[k2].childs[k3].visible = false
            }
          }
        }
      }
    }
  },

  removeFile (state, id) {
    var files = { ...state.files }
    delete files[id]

    state.files = files
  },

  removeCategory (state, id) {
    var cat = { ...state.categories }
    for (var k in cat) {
      if (cat[k].id == id) {
        delete cat[k]
      } else {
        for (var k2 in cat[k].childs) {
          if (cat[k].childs[k2].id == id) {
            delete cat[k].childs[k2]
          } else {
            for (var k3 in cat[k].childs[k2].childs) {
              if (cat[k].childs[k2].childs[k3].id == id) {
                delete cat[k].childs[k2].childs[k3]
              }
            }
          }
        }
      }
    }

    state.categories = cat
  },

  addSection (state, section) {
    var cat = { ...state.categories }
    if (section.parent_id == -1) {
      cat[section.id] = section
    } else {
      for (var k in cat) {
        if (cat[k].id == section.parent_id) {
          cat[k].childs[section.id] = section
        } else {
          for (var k2 in cat[k].childs) {
            if (cat[k].childs[k2].id == section.parent_id) {
              cat[k].childs[k2].childs[section.id] = section
            }
          }
        }
      }
    }

    state.categories = cat
  },

  setUrl (state, data) {
    state.url = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
